module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$isModuleEnabled(_vm.module)) ? _c('div', {
    staticClass: "component-is-module-enabled"
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-330a955a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/IsModuleEnabled.vue
// module id = 2392
// module chunks = 1